import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import {
	ConfirmBankAccountRes,
	UpsertBankAccountRes,
	VerifyBankIdentifiersDto,
	VerifyBankIdentifiersRes,
	PatchShareholderInvestorBankAccountDto,
	ShareholderInvestorPersonBankAccountsRes,
} from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';

export const getBankAccount = async (showPivAccounts: boolean, signal: AbortSignal | undefined) => {
	return await makeRequest<ApiV1.Response<ShareholderInvestorPersonBankAccountsRes[]>>(
		{
			endpoint: API_PATHS.SHAREHOLDER_BANK_ACCOUNT_GET,
			method: HTTP_METHOD.GET,
			queryString: {
				showPivAccounts,
			},
		},
		{ abortSignal: signal }
	).then((response) => response.payload);
};

export const upsertBankAccount = async (
	args: {
		body: PatchShareholderInvestorBankAccountDto;
		personId: string;
	},
	options?: ServiceRequestOptions
) => {
	return await makeRequest<ApiV1.Response<UpsertBankAccountRes>>(
		{
			endpoint: API_PATHS.SHAREHOLDER_BANK_ACCOUNT_POST,
			method: HTTP_METHOD.POST,
			queryString: {
				personId: args.personId,
			},
			body: JSON.stringify(args.body),
		},
		{
			...options,
		}
	);
};

export const validateShareholderBankAccount = async (
	args: { bankAccountId: string; body: VerifyBankIdentifiersDto },
	options?: ServiceRequestOptions
) => {
	return await makeRequest<ApiV1.Response<VerifyBankIdentifiersRes>>(
		{
			endpoint: formatUnicorn(API_PATHS.SHAREHOLDER_BANK_ACCOUNT_ID_VALIDATE_POST, {
				id: args.bankAccountId,
			}),
			method: HTTP_METHOD.POST,
			body: JSON.stringify(args.body),
		},
		{
			...options,
		}
	);
};

export const deleteShareholderBankAccount = async (
	args: { bankAccountId: string },
	options?: ServiceRequestOptions
) => {
	await makeRequest(
		{
			endpoint: formatUnicorn(API_PATHS.SHAREHOLDER_BANK_ACCOUNT_ID_DELETE, {
				id: args.bankAccountId,
			}),
			method: HTTP_METHOD.DELETE,
		},
		{
			...options,
		}
	);
};

export const requestBankAccountCode = async (
	args: { bankAccountId: string },
	options?: ServiceRequestOptions
) => {
	await makeRequest(
		{
			endpoint: formatUnicorn(API_PATHS.SHAREHOLDER_BANK_ACCOUNT_ID_REQUEST_CODE_POST, {
				id: args.bankAccountId,
			}),
			method: HTTP_METHOD.POST,
		},
		{
			...options,
		}
	);
};

export const confirmBankAccount = async (
	args: { bankAccountId: string; magicCode: string },
	options?: ServiceRequestOptions
) => {
	return await makeRequest<ApiV1.Response<ConfirmBankAccountRes>>(
		{
			endpoint: formatUnicorn(API_PATHS.SHAREHOLDER_BANK_ACCOUNT_ID_CONFIRM_POST, {
				id: args.bankAccountId,
			}),
			method: HTTP_METHOD.POST,
			body: JSON.stringify({ magicCode: args.magicCode }),
		},
		{
			...options,
		}
	);
};
